import { render } from "./FilterLoyaltyPointStatus.vue?vue&type=template&id=68322dc2"
import script from "./FilterLoyaltyPointStatus.vue?vue&type=script&lang=js"
export * from "./FilterLoyaltyPointStatus.vue?vue&type=script&lang=js"
script.render = render

export default script